import React from 'react';

// Walkthrough Editor v2 — step advance triggers (BL-144, redesigned).
// Three tap-cards: "Click hotspot" and "Next button" are independent (pick one
// or both); "Auto" is exclusive and reveals a delay. Persists to step.advance.
// The renderers honour this: the Classic/Spotlight runtimes wire it up in BL-153.

export const DEFAULT_ADVANCE = { hotspot: true, nextButton: false, auto: false, autoDelay: 3 };

const HandIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12" /><path d="M11 12V4.5a1.5 1.5 0 0 1 3 0V12" /><path d="M14 12.5V6.5a1.5 1.5 0 0 1 3 0V14a6 6 0 0 1-6 6h-1a6 6 0 0 1-5.2-3l-2.3-4a1.5 1.5 0 0 1 2.6-1.5L8 14" /></svg>
);
const NextIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="3" /><path d="M10 9l3 3-3 3" /></svg>
);
const ClockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);

const WalkthroughAdvanceControl = ({ value, onChange }) => {
  const adv = { ...DEFAULT_ADVANCE, ...(value || {}) };
  const set = (patch) => onChange({ ...adv, ...patch });

  const toggleInteractive = (key) => () => set({ [key]: !adv[key], auto: false });
  const toggleAuto = () => {
    if (adv.auto) set({ auto: false, hotspot: true });
    else set({ auto: true, hotspot: false, nextButton: false });
  };

  const hotspotOn = adv.hotspot && !adv.auto;
  const nextOn = adv.nextButton && !adv.auto;

  const cards = [
    { key: 'hotspot', label: 'Click hotspot', icon: <HandIcon />, on: hotspotOn, onClick: toggleInteractive('hotspot') },
    { key: 'nextButton', label: 'Next button', icon: <NextIcon />, on: nextOn, onClick: toggleInteractive('nextButton') },
    { key: 'auto', label: 'Auto', icon: <ClockIcon />, on: adv.auto, onClick: toggleAuto }
  ];

  return (
    <div className="un-we-adv">
      <div className="un-we-adv__grid">
        {cards.map((c) => (
          <button
            key={c.key}
            type="button"
            className={`un-we-adv__card${c.on ? ' on' : ''}`}
            aria-pressed={c.on}
            onClick={c.onClick}
          >
            <span className="un-we-adv__ic">{c.icon}</span>
            <span className="un-we-adv__lbl">{c.label}</span>
          </button>
        ))}
      </div>

      {adv.auto && (
        <div className="un-we-adv__delay">
          Advance after
          <input
            type="number"
            min="1"
            value={adv.autoDelay}
            onChange={(e) => set({ autoDelay: Math.max(1, Number(e.target.value) || 1) })}
          />
          seconds
        </div>
      )}
    </div>
  );
};

export default WalkthroughAdvanceControl;
